export default __webpack_public_path__ + "static/digital_transformation-0e20da3654bc47c5bf43f1a12f169d91.svg";